"use client";
import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import { videoEditingAboutData, videoEditingAndProcessData, videoEditingFaqs, videoHeroData } from "src/utils/mock/video-editing";
import EditingProjectOverView from "./EditingProjectOverView";

export default function VideoEditingComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const videoEditingProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";

    const hasAiTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("video-editing"));

    return isActive;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: videoEditingProjects,
    },
  };
  const videoEditingTechs = [
    { name: "Adobe Premiere Pro", icon: "/images/icons/premiere.svg" },
    { name: "After Effects", icon: "/images/icons/aftereffects.svg" },
    { name: "Photoshop", icon: "/images/icons/photoshop.svg" },
    { name: "Illustrator", icon: "/images/icons/ai.webp" },
    { name: "Audition", icon: "/images/icons/audition.svg" },
    { name: "DaVinci Resolve", icon: "/images/icons/davinci.svg" },
    { name: "Canva Pro", icon: "/images/icons/canva.webp" },
  ];
  return (
    <div>
      <AppHero heroData={videoHeroData} />
      <TechStats />

      <WhyChooseUs data={videoEditingAndProcessData} />

      <section className="w-full  px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <EditingProjectOverView />
          <ProcessStepsSection techIcons={videoEditingTechs} />
          <TechsSection sections={videoEditingAboutData} mainTitle="About Our Video Editing Development" />
        </div>
      </section>

      <FAQSection faqs={videoEditingFaqs} />
      <CommonContactSection />
    </div>
  );
}
